/*
 * Copyright (c) 2016-2018. campoint AG.
 * This file is licensed under the MIT License (https://opensource.org/licenses/MIT).
 */

import { decode } from 'xmlentities';

const plusPattern = /\+/g;
const commandPattern = /^CMDC_(\w+)/;
const valuePattern = /(\w+)=(\S+)/g;

export interface ResponseCommand {
    command: string;
    id: string;
    values: any;
}

export default class Response {
    public static readonly TIMEOUT: Response = new Response(10, 'timeout');
    public static readonly NETWORK_ERROR: Response = new Response(20, 'network error');

    public static parse(responseStr: string): Response {
        const response: Response = new Response();
        let result: string[];

        for (const line of responseStr.split('\n')) {
            result = commandPattern.exec(line);
            if (!result) {
                continue;
            }

            const cmdStr: string = result[1];

            const values = Response.parseValues(line, cmdStr);

            switch (cmdStr) {
                case 'RESULT':
                    response.code = Number.parseInt(values['code'], 10);
                    response.reason = values['reason'];
                    response.time = values['_t'] ? Number.parseInt(values['_t'], 10) : 0;
                    response.ok = response.code === 2000;
                    break;
                case 'VALUE':
                    for (const key in values) {
                        if (Object.prototype.hasOwnProperty.call(values, key)) {
                            response.values[key] = values[key];
                        }
                    }
                    break;
                default:
                    response.commands.push({
                        command: cmdStr,
                        id: values.commandID,
                        values: values,
                    });
            }
        }

        return response;
    }

    public ok = false;
    public code: number;
    public reason = '';
    public time = 0;

    public values: any = {};
    public commands: Array<ResponseCommand> = [];

    constructor(code = 0, reason?: string) {
        this.code = code;
        this.reason = reason;
    }

    private static parseValues(line: string, cmdStr: string): any {
        const values: any = {};
        let result: string[];

        valuePattern.lastIndex = 0;
        while ((result = valuePattern.exec(line))) {
            const key: string = result[1];
            const value: string = decode(decodeURIComponent(result[2]));
            values[key] =
                key === 'text' &&
                value.slice(0, 7) !== '<a+href' &&
                cmdStr !== 'CQUERYUSER' &&
                !line.includes(' from=system')
                    ? value
                    : value.replace(plusPattern, ' ');
        }
        return values;
    }

    public toString(): string {
        return (
            '[ok=' +
            this.ok +
            ', code=' +
            this.code +
            ', reason=' +
            this.reason +
            ', time=' +
            this.time +
            ', values=' +
            this.values +
            ', commands=' +
            this.commands +
            ']'
        );
    }
}
